export default __webpack_public_path__ + "images/6T.ef486d9.png";